/**
 * Logo, banner and footer.
 *
 * The name is the joke: at roll call in a Brazilian school a child answers
 * "presente!", and a present is what you bring to the party. The mark is a
 * wrapped gift, kept to four shapes so it survives being 16px in a tab.
 */

export function Logo({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label="Presente!"
      style={{ flexShrink: 0 }}
    >
      <rect width="32" height="32" rx="8" fill="var(--pink)" />
      <rect x="5.5" y="14" width="21" height="12.5" rx="2" fill="#fffdfb" />
      <rect x="4.5" y="12" width="23" height="4.5" rx="1.5" fill="#fffdfb" />
      <rect x="14.25" y="12" width="3.5" height="14.5" fill="var(--pink)" />
      <path
        d="M16 12c-1.2-3.2-3.6-5-5.6-4.1-1.7.8-1.5 3.2.6 4.1M16 12c1.2-3.2 3.6-5 5.6-4.1 1.7.8 1.5 3.2-.6 4.1"
        fill="none"
        stroke="#fffdfb"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * The banner.
 *
 * On a guest's invitation it is deliberately quiet: she is here for the party,
 * not for us, and the 60-second clock is running.
 */
export function Banner({ quiet = false }: { quiet?: boolean }) {
  return (
    <header className={`banner-bar${quiet ? ' quiet' : ''}`}>
      <a className="brand" href="/">
        <Logo size={quiet ? 26 : 32} />
        <span className="wordmark">Presente!</span>
      </a>
      {!quiet && <span className="tagline">confirme quem vem</span>}
    </header>
  );
}

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      {/* One line, wrapping where it must. Three stacked paragraphs took as
          much room as a section and read like one. */}
      <p>
        © {year} Presente! · feito por{' '}
        <a
          href="https://www.linkedin.com/in/leomrlima/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Leonardo Lima
        </a>{' '}
        · <a href="/contato">Fale com a gente</a> · Tudo é apagado 2 dias
        depois da festa.
      </p>
    </footer>
  );
}

/** Page chrome: banner, content, footer. */
export function Shell({
  children,
  quiet = false,
}: {
  children: React.ReactNode;
  quiet?: boolean;
}) {
  return (
    <>
      <Banner quiet={quiet} />
      {/* A main landmark, so a screen reader can skip straight to the point. */}
      <main>{children}</main>
      <Footer />
    </>
  );
}
